var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5036 1.99415C15.8219 0.349232 13.4814 1.01211 12.0754 2.06801C11.4988 2.50096 11.2106 2.71743 11.041 2.71743C10.8714 2.71743 10.5832 2.50096 10.0066 2.06801C8.60063 1.01211 6.2601 0.349232 3.57845 1.99415C0.0590844 4.15294 -0.737265 11.2749 7.38054 17.2834C8.92673 18.4278 9.69981 19 11.041 19C12.3822 19 13.1553 18.4278 14.7015 17.2834C22.8193 11.2749 22.0229 4.15294 18.5036 1.99415Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.fd51e4cf5b03120e90509bd89731e1ab.svg";
export { ForwardRef as ReactComponent };